import React from 'react';
import { useMobileChart } from '../../context/MobileChartContext';

interface ScoreTriggerProps {
  score: number | string;
  title: string;
  label?: string;
  status?: string;
  icon?: React.ReactNode;
  chartComponent: React.ReactNode;
  className?: string;
}

/**
 * A component that displays a score and triggers a chart overlay on mobile
 * when tapped. On desktop, this component does not change the existing behavior.
 */
const ScoreTrigger: React.FC<ScoreTriggerProps> = ({
  score,
  title,
  label,
  status,
  icon,
  chartComponent,
  className = '',
}) => {
  const { isMobile, openChart } = useMobileChart();
  
  const handleClick = () => {
    if (isMobile) {
      openChart('custom', title, chartComponent);
    }
  };
  
  return (
    <div 
      className={`${className} ${isMobile ? 'cursor-pointer active:bg-slate-50' : ''}`}
      onClick={isMobile ? handleClick : undefined}
    >
      <div className="flex items-center gap-2">
        {icon && <div className="flex-shrink-0">{icon}</div>}
        <div>
          <div className="flex items-baseline gap-1">
            <span className="text-2xl font-bold">{score}</span>
            {label && <span className="text-sm text-slate-500">{label}</span>}
          </div>
          {status && (
            <div className="text-sm font-medium text-slate-700">{status}</div>
          )}
          <div className="text-sm font-medium text-slate-500">{title}</div>
          {isMobile && (
            <div className="text-xs text-blue-600 mt-1">Tap to view chart</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ScoreTrigger; 